import type { ReactNode } from "react";

import useCampaignParams from "~/hooks/useCampaignParams";
import useGtagPageTracking from "~/hooks/useGtagPageTracking";
import {
  identifyUser as gtagIdentifyUser,
  trackEvent as gtagTrackEvent,
} from "~/lib/gtag";
import { PostHogProvider } from "~/lib/posthog";
import {
  identifyUser as posthogIdentifyUser,
  trackEvent as posthogTrackEvent,
} from "~/lib/posthog/analytics";
import { identifyUser as sentryIdentifyUser } from "~/lib/sentry";

const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  // Track page views with Google Analytics
  useGtagPageTracking();
  // Capture UTM/click ID params from URL into localStorage
  useCampaignParams();

  return <PostHogProvider>{children}</PostHogProvider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const identifyUser = ({
  id,
  name,
  email,
  userType,
}: {
  id: string;
  name: string;
  email: string;
  userType: string;
}) => {
  posthogIdentifyUser({ id, name, email, userType });
  sentryIdentifyUser({ id, name, email });
  gtagIdentifyUser(id);
};

// eslint-disable-next-line react-refresh/only-export-components
export const trackEvent = (event: string, properties?: object) => {
  posthogTrackEvent(event, properties);
  gtagTrackEvent(event, properties);
};

export default AnalyticsProvider;
